import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { getOtaList, deleteOtaTask, cancelTask } from '@blade-sxp/ota-management/api/index';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    keywords;
    groupId;
    confirm = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    loading = false;
    devicesList = [];
    // 过滤参数
    deviceStatus = '';
    taskStatus = '';
    colors = colors;
    get deviceStatusFilter() {
        return [
            { text: this.$t('online'), value: 'ON_LINE' },
            { text: this.$t('offline'), value: 'OFF_LINE' },
        ];
    }
    get taskStatusFilter() {
        return [
            { text: this.$t('succeed'), value: 'SUCCESS' },
            { text: this.$t('failure'), value: 'FAIL' },
            { text: this.$t('updating'), value: 'DOING' },
            { text: this.$t('waiting'), value: 'WAITING' },
            { text: this.$t('cancel'), value: 'CANCEL' },
        ];
    }
    /**
     *@Description: 筛选向后段发送请求
     *@Date: 2020-09-10 18:20:13
     */
    getKey(obj) {
        for (let key in obj) {
            return key;
        }
    }
    handleFilterChange(filters) {
        let key = this.getKey(filters);
        if (key) {
            if (key === 'deviceStatusList') {
                this.deviceStatus = filters[key][0];
            }
            else {
                this.taskStatus = filters[key][0];
                this.pagination.page = 1;
                this.refresh();
            }
        }
    }
    cancelTask(id) {
        cancelTask(id)
            .then((resp) => {
            this.$message({
                message: resp.data.message,
                type: 'success',
            });
            this.refresh();
        })
            .catch((err) => {
            this.$message.error(err.toString());
        });
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.pagination.page = 1;
        this.refresh();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.refresh();
    }
    pauseTask(id) { }
    /**
     *@Description: 获取设备列表
     *@Date: 2020-09-10 18:17:12
     */
    getDevicesList(keywords) {
        this.loading = true;
        let data = {
            keyword: keywords,
            taskStatus: this.taskStatus,
            page: this.pagination.page,
            size: this.pagination.size,
        };
        getOtaList(data)
            .then((resp) => {
            this.devicesList = resp?.data?.data?.list || [];
            this.pagination.total = resp?.data?.data?.total;
            this.loading = false;
        })
            .catch((err) => {
            this.loading = false;
            this.$message.error(err.toString());
        });
    }
    /**
     *@Description:  跳转编辑设备
     *@Date: 2020-09-10 18:16:57
     */
    handleDetail(sid) {
        const id = sid.toString() || '';
        this.$router.push({ path: '/setting/otaManagement/otaDetail', query: { taskId: id } });
    }
    handleEdit(row) {
        const id = row.taskId.toString() || '';
        this.$router.push({ path: '/setting/otaManagement/editOta', query: { taskId: id } });
    }
    /**
     *@Description: 删除设备
     *@Date: 2020-09-10 18:16:47
     */
    handleDelete(sid) {
        this.$elconfirm(this.$t('common.selectDelete').toString(), this.$t('common.warning').toString(), {
            type: 'warning',
            center: true,
            confirmButtonText: this.$t('common.confirm').toString(),
            callback: (action) => {
                if (action === 'confirm') {
                    deleteOtaTask(sid)
                        .then((res) => {
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                        });
                        this.refresh();
                    })
                        .catch((err) => {
                        this.$message({
                            message: err,
                            type: 'error',
                        });
                    });
                }
            },
        });
    }
    refresh() {
        this.getDevicesList(this.keywords);
    }
    mounted() {
        this.refresh();
    }
};
__decorate([
    Prop()
], default_1.prototype, "keywords", void 0);
__decorate([
    Prop()
], default_1.prototype, "groupId", void 0);
default_1 = __decorate([
    Component({
        name: 'OTADeviceList',
        components: { AuthItem },
        filters: {
            toFormat: (num) => {
                return num ? moment(num).format('YYYY-MM-DD hh:mm:ss') : '';
            },
        },
        i18n: {
            messages: {
                'en-us': {
                    unusual: 'unusual',
                    Numbering: 'index',
                    packageName: 'Update Package',
                    packageVsn: 'Update Version',
                    packageType: 'Package Type',
                    currentPackageVsn: 'Current Version',
                    deviceType: 'Device type',
                    deviceCnt: 'Device Quantity',
                    deviceStatus: 'Device Status',
                    online: 'Online',
                    offline: 'Offline',
                    taskStatus: 'Task Status',
                    success: 'Success',
                    fail: 'Fail',
                    waiting: 'Pending',
                    cancel: 'Canceled',
                    updating: 'Updating',
                    taskExecuteTime: 'Execution Time',
                    taskleftSecond: 'The countdown',
                    taskCreateTime: 'Creation Time',
                    creatorName: 'Creator',
                    details: 'details',
                    exportedData: 'Please select the data to be exported',
                    normal: 'Normal',
                    deviceGroup: 'Associated Device Group',
                    succeed: 'Update Success',
                    failure: 'Update Fail',
                },
                zh: {
                    unusual: '异常',
                    Numbering: '编号',
                    packageName: '更新包名称',
                    packageVsn: '更新包版本',
                    packageType: '更新包类型',
                    currentPackageVsn: '当前版本',
                    deviceType: '设备类型',
                    deviceCnt: '设备数量',
                    deviceStatus: '已选中设备状态',
                    online: '在线',
                    offline: '离线',
                    taskStatus: '任务状态',
                    success: '成功',
                    fail: '失败',
                    waiting: '待更新',
                    cancel: '取消更新',
                    updating: '更新中',
                    taskExecuteTime: '任务执行时间',
                    taskleftSecond: '倒计时',
                    taskCreateTime: '任务创建时间',
                    creatorName: '任务创建人',
                    details: '详情',
                    exportedData: '请选择需要导出的数据',
                    normal: '已连接',
                    deviceGroup: '关联设备组',
                    succeed: '更新成功',
                    failure: '更新失败',
                },
            },
        },
    })
], default_1);
export default default_1;
